import { SwapOutlined } from "@ant-design/icons"
import { type CurrencyEnum, PriceIntervalEnum, type Transaction } from "@finway-group/shared/lib/models"
import moment from "moment"
import React from "react"
import { ExpenseConversionInfo } from "~Components/expenseConversionInfo"
import { PriceLabel } from "~Components/priceLabel"
import { shouldDisplayTransactionConversion } from "~Shared/utils/transaction.utils"

interface TransactionAmountColumnProps {
    transaction: Transaction
    expenseCurrency?: CurrencyEnum
}

export const TransactionAmountColumn = ({ transaction, expenseCurrency }: TransactionAmountColumnProps) => {
    const displayConversion = shouldDisplayTransactionConversion(transaction, expenseCurrency)

    return (
        <div className="flex align-middle gap-8 justify-start">
            <div className={`flex`}>
                <PriceLabel value={transaction.transactionData.amount} currency={transaction.transactionData.currency} interval={PriceIntervalEnum.ONE_TIME} addPlusSign />
            </div>

            {displayConversion && (
                <>
                    <div className="text-xs opacity-75">
                        <SwapOutlined />
                    </div>
                    <div>
                        <ExpenseConversionInfo
                            className="text-xs pt-2"
                            value={Math.abs(transaction.transactionData.amount)}
                            sourceCurrency={transaction.transactionData.currency}
                            destCurrency={expenseCurrency}
                            showSourceAmount={false}
                            exchangeDate={transaction.transactionData?.date ? moment(transaction.transactionData.date) : undefined}
                            sourceAmount={transaction.sourceAmount}
                            size="sm"
                        />
                    </div>
                </>
            )}
        </div>
    )
}
